import { getRequest } from 'config/Axios/baseConfig';
import { DetailedScheduleResponse } from 'screens/DetailedScheduleScreen/detailedScheduleTypes';

export const detailedScheduleService = {
  getDetailedSchedule: (date: string): Promise<DetailedScheduleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await getRequest<DetailedScheduleResponse>(
          `pps/detailed_schedule/${date}`
        );
        resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
